<template>
    <div class="fixed z-index-modal top-0 overflow-hidden duration-500"
        :class="isOpen ? 'sidebar-open' : 'sidebar-close'">
        <div class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0" v-if="isOpen" @click="closeMenu()">
        </div>
        <div class="w-full h-screen bg-a-egg-f5ebdc relative flex flex-col">
            <div class="text-16 lg:text-24 font-bold py-6 text-center text-a-brown-502314">Notifications</div>
            <div class="absolute top-6 right-6">
                <button type="button" class="outline-none appearance-none bg-none">
                    <img class="" @click="closeMenu()" src="@/assets/icon/ic-close-brown.svg" />
                </button>
            </div>
            <div class="mx-3 lg:mx-6 lg:mt-2 mb-6 lg:mb-8">
                <NotificationToggle v-model="isNotificationOn"></NotificationToggle>
            </div>
            <div class="flex-auto overflow-y-auto" @scroll="onScroll($event)">
                <NotificationList :isOn="isNotificationOn" :items="arrNotifications"></NotificationList>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, inject, watch, ref, onMounted } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

//component
import NotificationToggle from './components/NotificationToggle.vue';
import NotificationList from './components/NotificationList.vue';

//mixin
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
import ModalMixin from '@/mixin/ModalMixin.js';

export default {
    name: "ShoppingBag",
    mixins: [DeliveryMixin, ModalMixin],
    inject: ['CartCountStore'],
    components: {
        NotificationToggle,
        NotificationList
    },
    setup: function () {
        const SideMenuStore = inject("SideMenuStore")
        const AccountStore = inject("AccountStore")
        const NotificationStore = inject("NotificationStore")
        const tracking = inject('trackingService');
        const isOpen = computed(() => {
            return SideMenuStore.state.notification
        })
        const isNotificationOn = ref(false)

        if (JSON.parse(localStorage.getItem("notificationsEnabled")) === true) {
            isNotificationOn.value = true
        }

        //#region watch
        watch(isNotificationOn, val => {
            if (val) {
                if (AccountStore.getters.isLoginAccount.value == true && isNotificationOn.value) {
                    // get notification
                    NotificationStore.methods.getNotifications()
                    setTimeout(() => {
                        //call tracking service
                        trackingService();
                    }, 1000);

                }
            } else {
                NotificationStore.methods.clear()
            }
        })

        watch(() => SideMenuStore.state.notification, (val) => {
            // setTimeout(() => {

            // }, 500);
            if (val) {
                document.body.classList.add('not-scroll');
            } else {
                document.body.classList.remove('not-scroll');
            }
        })

        watch(() => SideMenuStore.state.notification, val => {
            if (val) {
                NotificationStore.methods.getNotifications()
                //call tracking service
                trackingService();
            }
        })
        //#endregion

        //#region methods
        const closeMenu = function () {
            SideMenuStore.methods.toggleSideMenu("notification", false);
        }
        const onScroll = function (e) {
            /**@type {HTMLElement} */
            const el = e.target
            if (el.scrollTop > 0) {
                el.classList.add("shadow-inner")
            } else {
                el.classList.remove("shadow-inner")
            }
        }
        //#endregion

        // pass function to before route leave
        onBeforeRouteLeave(closeMenu)

        AccountStore.methods.loginStatus().subscribe((status) => {
            if (status && AccountStore.getters.isLoginAccount.value == true && isNotificationOn.value) {
                // get notification
                NotificationStore.methods.getNotifications()
            }
        })

        // Tracking Sesssion
        const trackingService = function(){
            console.log(isNotificationOn.value)
            // Check notification turn on
            if(isNotificationOn.value == true){
                // Check having notification list
                let notiList = NotificationStore.items.value

                let messageLabel = "";
                if(notiList.length > 0){
                    messageLabel += '|';
                    notiList.forEach(noti => {
                            messageLabel += ` ${noti.message}`
                    });
                }

                tracking.event('notification','view notification list',`notification${messageLabel}`)
            }
        }


        onMounted(()=>{
        });


        return {
            isOpen,
            SideMenuStore,
            isNotificationOn,
            closeMenu,
            onScroll,
            arrNotifications: NotificationStore.items
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.sidebar-open {
    width: 100vw;
    right: 0px;

    @include min-desktop {
        width: 456px;
    }
}

.sidebar-close {
    width: 100vw;
    right: -100vw;

    @include min-desktop {
        width: 456px;
        right: -456px;
    }
}

.order-empty-screen {
    height: calc(100vh - 77px);
}
</style>
